import React from 'react';
import HeroBanner from '../components/HeroBanner';
import BestSellerFruits from '../components/BestSellerFruits';

const Home = () => {
  return (
    <div>
      <main>
        <HeroBanner />
        <div style={{ padding: '20px' }}>
          <h2>Best Seller Fruits</h2>
          <p>Fresh and organic fruits loved by our customers.</p>
          <BestSellerFruits />
        </div>
      </main>
    </div>
  );
};

export default Home;
